(function () {
    'use strict';

    angular
        .module('app.accountSettings')
        .constant('homeCourseResolver', {
            facility: create('facility'),
            course: create('course'),
            tee: create('tee'),
            returnState: getReturnState
        });

    var extend = angular.extend,
        identity = angular.identity,
        isEqual = function (property, value) { return function find(obj) { return obj[property] == value; } },
        getter = function (property) { return function getter(obj) { return obj[property]; } };

    function create(property) {
        resolve.$inject = ['$transition$', '$q', 'user', 'Course', 'nationalAssociation']
        return resolve;

        function resolve($transition$, $q, user, Course, nationalAssociation) {
            if (!$transition$.resolvePromise)
                $transition$.resolvePromise = getData($q, user, Course, nationalAssociation);

            return $transition$.resolvePromise.then(getter(property));

            function getData($q, user, Course, nationalAssociation, homeStateName) {
                var defaults = user.scoreDefaults || {},
                    nationalAssociation = defaults.nationalAssociation || nationalAssociation.RCGA,
                    result = extend({}, defaults, { nationalAssociation: nationalAssociation, facility: null, course: null, tee: null, returnState: null });

                return $q.resolve(result)
                    .then(getCourses)
                    .then(setFacility)
                    .then(setCourse)
                    .then(setTee)
                    .catch(identity)
                    .then(transform);

                function getCourses(result) {
                    var facilityId = result.facilityId;
                    return facilityId ? Course.getCourses({ facilityId: facilityId }).$promise.then(success, error) : error();

                    function success(courses) {
                        return extend(result, { courses: courses });
                    }
                    function error() {
                        return $q.reject(result);
                    }
                }
                function setFacility(result) {
                    var facility = { id: result.facilityId, name: result.facilityName, nationalAssociation: result.nationalAssociation, courses: result.courses };
                    return extend(result, { facility: facility });
                }
                function setCourse(result) {
                    var courses = result.facility.courses,
                        courseId = result.courseId,
                        course = courseId && courses.find(isEqual('id', courseId)) || null;
                    return course ? extend(result, { course: course }) : $q.reject(result);
                }

                function setTee(result) {
                    var tees = result.course.tees,
                        teeId = result.teeId,
                        tee = teeId && tees.find(isEqual('id', teeId)) || null;

                    return tee ? extend(result, { tee: tee }) : $q.reject(result);
                }

                function transform(result) {
                    return { facility: result.facility, course: result.course, tee: result.tee };
                }
            }
        }
    }

    getReturnState.$inject = ['$transition$', 'homeStateName'];
    function getReturnState($transition$, homeStateName) {
        var state = $transition$.from();
        return state.name != '' ? state : homeStateName;
    }
})();

